export function normalizeDiscountScope(scope) {
  if (scope === "vaca" || scope === "bufalo") return scope;
  return "general";
}

/** Reparte los litros de descuento según el tipo elegido. */
export function splitDayDiscount(vacaGross = 0, bufaloGross = 0, discount = 0, scope = "general") {
  const vaca = Math.max(0, Number(vacaGross) || 0);
  const bufalo = Math.max(0, Number(bufaloGross) || 0);
  const mode = normalizeDiscountScope(scope);
  const cap = mode === "vaca" ? vaca : mode === "bufalo" ? bufalo : vaca + bufalo;
  const clamped = Math.max(0, Math.min(Number(discount) || 0, cap));
  let vacaDisc = 0;
  let bufaloDisc = 0;
  if (mode === "bufalo") {
    bufaloDisc = Math.min(clamped, bufalo);
  } else if (mode === "vaca") {
    vacaDisc = Math.min(clamped, vaca);
  } else {
    vacaDisc = Math.min(clamped, vaca);
    bufaloDisc = Math.min(clamped - vacaDisc, bufalo);
  }
  return {
    discount: vacaDisc + bufaloDisc,
    vacaDisc,
    bufaloDisc,
    netVaca: vaca - vacaDisc,
    netBufalo: bufalo - bufaloDisc,
    scope: mode,
  };
}

export function milkPayStatus(provider) {
  const pending = Number(provider?.pendingAmount) || 0;
  const owed = Number(provider?.totalOwed) || 0;
  const paid = Number(provider?.totalPaid) || 0;
  if (pending > 0.01) return "pending";
  if (owed > 0.01 || paid > 0.01) return "paid";
  return "idle";
}

export function providerDiscountLiters(provider) {
  if (provider?.discountLiters != null && provider.discountLiters !== "") {
    return Number(provider.discountLiters) || 0;
  }
  return Object.values(provider?.daily || {}).reduce(
    (acc, cell) => acc + (Number(cell?.discount) || 0),
    0,
  );
}

/** Litros físicos traídos (sin restar descuento de agua). */
export function providerGrossLiters(provider, milkType = "vaca") {
  if (milkType === "bufalo" && provider?.grossLitersBufalo != null) {
    return Number(provider.grossLitersBufalo) || 0;
  }
  if (milkType !== "bufalo" && provider?.grossLitersVaca != null) {
    return Number(provider.grossLitersVaca) || 0;
  }
  const key = milkType === "bufalo" ? "bufalo" : "vaca";
  const daily = provider?.daily || {};
  const keys = Object.keys(daily);
  if (keys.length) {
    return keys.reduce((acc, date) => acc + (Number(daily[date]?.[key]) || 0), 0);
  }
  // Fallback: liters* en API son netos (para pago).
  return milkType === "bufalo"
    ? Number(provider?.litersBufalo) || 0
    : Number(provider?.litersVaca) || 0;
}

export function paymentUsd(pay) {
  if (Number.isFinite(pay?.amountInUSD)) return Number(pay.amountInUSD);
  if (Number.isFinite(pay?.conversionDetails?.amountInUSD)) {
    return Number(pay.conversionDetails.amountInUSD);
  }
  if (String(pay?.currency || "USD").toUpperCase() === "BS") return 0;
  return Number(pay?.amount) || 0;
}

export function normalizeMilkPayment(pay, fallbackRate = 0) {
  const usd = paymentUsd(pay);
  const details = pay?.conversionDetails || {};
  let rate = Number(details.exchangeRate) || Number(fallbackRate) || 0;
  const currency = String(pay?.currency || "USD").toUpperCase();
  const rawAmount = Number(pay?.amount) || 0;
  let bs = 0;
  if (currency === "BS" && rawAmount > 0) {
    bs = rawAmount;
    if (!(rate > 0) && usd > 0) rate = bs / usd;
  } else if (usd > 0 && rate > 0) {
    bs = usd * rate;
  }
  const rawDate = pay?.paymentDate || pay?.createdAt || null;
  return { usd, rate, bs, date: rawDate, reference: pay?.reference || "" };
}

/** Semana de leche: jueves a miércoles. Devuelve YYYY-MM-DD del jueves. */
export function getMilkWeekStartKey(value = new Date()) {
  const text = String(value || "").trim();
  let target;
  if (/^\d{4}-\d{2}-\d{2}$/.test(text.slice(0, 10))) {
    const [year, month, day] = text.slice(0, 10).split("-").map(Number);
    target = new Date(year, month - 1, day, 12, 0, 0, 0);
  } else {
    target = value instanceof Date ? new Date(value) : new Date();
  }
  if (Number.isNaN(target.getTime())) target = new Date();
  target.setHours(0, 0, 0, 0);
  const startDay = 4; // Jueves
  let daysSinceStart = target.getDay() - startDay;
  if (daysSinceStart < 0) daysSinceStart += 7;
  target.setDate(target.getDate() - daysSinceStart);
  const y = target.getFullYear();
  const m = String(target.getMonth() + 1).padStart(2, "0");
  const d = String(target.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

export function sortMilkPayments(payments = []) {
  return [...payments].sort((a, b) => {
    const da = new Date(a?.paymentDate || a?.createdAt || 0).getTime();
    const db = new Date(b?.paymentDate || b?.createdAt || 0).getTime();
    return da - db;
  });
}
